import "./UserInformation.css";
import {useI18n} from "../../i18n";
import React from "react";

const UserInformation = ({ userInfo }) => {
  const { t } = useI18n();

  return (
    <div className="bg-user-information rounded-3 p-3">
      <div className="text-center">
        <h5 className="text-warning"> {t('User_Information_Text')}</h5>
        <div className="underLineUserInfo my-3"></div>
      </div>
      {userInfo?.user_info?.occupation && (
        <div className="d-flex text-light mt-2">
          <p>
            <i className="fa-solid fa-briefcase mx-3"></i>
          </p>
          <p className="mx-1">{t('Works_as_Text')}</p>
          <p className="fw-bold ">{userInfo?.user_info?.occupation}</p>
        </div>
      )}

      {userInfo?.user_info?.edu_level && (
        <div className="d-flex text-light">
          <p>
            <i className="fa-solid fa-graduation-cap mx-3"></i>
          </p>
          <p className="mx-1">{t('Education_Text')}</p>
            <p className="fw-bold ">{userInfo?.user_info?.edu_level} {userInfo?.user_info?.institute && (<span> at {userInfo?.user_info?.institute}</span>)}</p>
        </div>
      )}

      {userInfo?.user_info?.country && (
        <div className="d-flex text-light">
          <p>
            <i className="fa-solid fa-house mx-3"></i>
          </p>
          <p className="mx-1">{t('Lives_in_Text')}</p>
          <p className="fw-bold ">{userInfo?.user_info?.country}</p>
        </div>
      )}
      {/* <div className="d-flex text-light">
        <p>
          <i className="fa-solid fa-house mx-3"></i>
        </p>
        <p className="mx-1">From</p>
        <p className="fw-bold ">Mymensingh,Dhaka, Bangladesh</p>
      </div> */}
      {userInfo?.user_info?.dob && (
        <div className="d-flex text-light">
          <p>
            <i className="fa-solid fa-cake-candles mx-3"></i>
          </p>
          <p className="mx-1">{userInfo?.user_info?.dob}</p>
          <p className="fw-bold "></p>
        </div>
      )}
    </div>
  );
};

export default UserInformation;
